// UC Riverside's undergraduate majors (#2596, founder 2026-09-30: "majors
// offered by the college in the public page"). Read on 2026-09-30 from UCR's
// official 2026-2027 General Catalog, which the Registrar publishes only as a
// PDF (documents.ucr.edu/registrar/UCR Catalog 2026-2027.pdf; the old
// catalog.ucr.edu now redirects to the Registrar). Each college prints an
// "Undergraduate Majors and Options" table (pp. 83, 91, 96, 100); the Schools
// of Education and Public Policy name their one B.A. in their sections
// (pp. 105, 110). The tables were read from the rendered pages, one entry per
// major and degree; options and emphases sit in the note. Left out: Black
// Study, Sustainability Studies and Biological Sciences, which the catalog
// marks as not open to new students, and the named combined majors
// (Economics/Administrative Studies and the like), which the Administrative
// Studies and Law and Society notes cover. The CNAS table prints Geology with
// no degree; the catalog's Degrees table (p. 7) gives it as a B.S.
// Neuroscience appears under both CHASS and CNAS, as in the catalog. No flags:
// the college file holds no page on major-level limits. The KB's list was the
// starting point; the catalog wins.
const majors = {
    "slug": "university-of-california-riverside",
    "read": "2026-09-30",
    "intro": "Every undergraduate major in UC Riverside's official 2026-2027 General Catalog, grouped by the college or school that offers it, with the degree it leads to. Programs closed to new students, minors and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Humanities, Arts, and Social Sciences",
            "source": {
                "label": "UCR General Catalog 2026-2027, College of Humanities, Arts, and Social Sciences, Undergraduate Majors and Options (p. 83)",
                "url": "https://documents.ucr.edu/registrar/UCR%20Catalog%202026-2027.pdf#page=83"
            },
            "majors": [
                {
                    "name": "Administrative Studies",
                    "degree": "B.A.",
                    "note": "Only offered as a major combined with another program: Art History, Economics, History, Political Science, Religious Studies or Sociology."
                },
                {
                    "name": "African American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.S."
                },
                {
                    "name": "Art (Studio)",
                    "degree": "B.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Asian American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Business Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Chicano Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Creative Writing",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Ethnic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Gender and Sexuality Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Global and Community Health",
                    "degree": "B.A."
                },
                {
                    "name": "Global Studies",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Humanities, Arts, and Social Sciences Interdisciplinary",
                    "degree": "B.A."
                },
                {
                    "name": "Languages and Literatures/Chinese",
                    "degree": "B.A."
                },
                {
                    "name": "Languages and Literatures/Classical Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Languages and Literatures/Comparative Ancient Civilizations",
                    "degree": "B.A."
                },
                {
                    "name": "Languages and Literatures/Comparative Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Languages and Literatures/French",
                    "degree": "B.A."
                },
                {
                    "name": "Languages and Literatures/Germanic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Languages and Literatures/Japanese",
                    "degree": "B.A."
                },
                {
                    "name": "Languages and Literatures/Languages",
                    "degree": "B.A."
                },
                {
                    "name": "Languages and Literatures/Russian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Law and Society",
                    "degree": "B.A.",
                    "note": "Only offered as a major combined with another program: Anthropology, Economics, History, Philosophy, Political Science, Psychology or Sociology."
                },
                {
                    "name": "Liberal Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Middle East and Islamic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Media and Cultural Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music and Culture",
                    "degree": "B.A."
                },
                {
                    "name": "Native American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.S."
                },
                {
                    "name": "Southeast Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre, Film and Digital Production",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Natural and Agricultural Sciences",
            "source": {
                "label": "UCR General Catalog 2026-2027, College of Natural and Agricultural Sciences, Undergraduate Majors and Options (p. 91)",
                "url": "https://documents.ucr.edu/registrar/UCR%20Catalog%202026-2027.pdf#page=91"
            },
            "majors": [
                {
                    "name": "Biochemistry",
                    "degree": "B.A.",
                    "note": "Emphases: Biology; Chemistry; Medical Sciences."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S.",
                    "note": "Emphases: Biology; Chemistry; Medical Sciences."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Cell, Molecular, and Developmental Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Cell, Molecular, and Developmental Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S.",
                    "note": "Options: Chemical Physics; Chemistry with Education Focus; Environmental Chemistry."
                },
                {
                    "name": "Earth Sciences",
                    "degree": "B.A.",
                    "note": "Options: Climate Change; Geobiology; Geophysics."
                },
                {
                    "name": "Earth Sciences",
                    "degree": "B.S.",
                    "note": "Options: Climate Change; Geobiology; Geophysics; Geosystems."
                },
                {
                    "name": "Genetics and Molecular Biotechnology",
                    "degree": "B.S."
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "Geophysics",
                    "degree": "B.S."
                },
                {
                    "name": "Entomology",
                    "degree": "B.A."
                },
                {
                    "name": "Entomology",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "B.A.",
                    "note": "Options: Atmospheric Sciences; Environmental Management; Environmental Toxicology; Hydrologic Sciences; Soil Sciences."
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "B.S.",
                    "note": "Options: Atmospheric Sciences; Environmental Management; Environmental Toxicology; Hydrologic Sciences; Soil Sciences."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A.",
                    "note": "Option: Pure Mathematics."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S.",
                    "note": "Option: Pure Mathematics."
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "B.A.",
                    "note": "Options: Biology; Chemistry; Economics; Environmental Sciences; Physics."
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "B.S.",
                    "note": "Options: Biology; Chemistry; Economics; Environmental Sciences; Physics."
                },
                {
                    "name": "Computational Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Computational Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics for Secondary School Teachers",
                    "degree": "B.S."
                },
                {
                    "name": "Microbiology",
                    "degree": "B.A."
                },
                {
                    "name": "Microbiology",
                    "degree": "B.S."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S.",
                    "note": "Options: Applied Physics and Engineering; Astrophysics; Biophysics; Physics Education."
                },
                {
                    "name": "Plant Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Plant Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Statistics",
                    "degree": "B.A."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S.",
                    "note": "Options: Statistical Computing; Quantitative Management."
                }
            ]
        },
        {
            "name": "Marlan and Rosemary Bourns College of Engineering",
            "source": {
                "label": "UCR General Catalog 2026-2027, Bourns College of Engineering, Undergraduate Majors and Options (p. 96)",
                "url": "https://documents.ucr.edu/registrar/UCR%20Catalog%202026-2027.pdf#page=96"
            },
            "majors": [
                {
                    "name": "Bioengineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S.",
                    "note": "Options: Biochemical Engineering; Chemical Engineering; Nanotechnology."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science and Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science with Business Applications",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S.",
                    "note": "Options: Air Pollution Control Technology; Water Pollution Control Technology."
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S.",
                    "note": "Options: Design and Manufacturing; Energy and Environment; General Mechanical Engineering; Mechanics of Materials and Structures."
                },
                {
                    "name": "Robotics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Business",
            "source": {
                "label": "UCR General Catalog 2026-2027, School of Business, Undergraduate Majors (p. 100)",
                "url": "https://documents.ucr.edu/registrar/UCR%20Catalog%202026-2027.pdf#page=100"
            },
            "majors": [
                {
                    "name": "Actuarial Science",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Business Analytics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "UCR General Catalog 2026-2027, The School of Education (p. 105)",
                "url": "https://documents.ucr.edu/registrar/UCR%20Catalog%202026-2027.pdf#page=105"
            },
            "majors": [
                {
                    "name": "Education, Society, and Human Development",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "School of Public Policy",
            "source": {
                "label": "UCR General Catalog 2026-2027, The School of Public Policy, Undergraduate Study (p. 110)",
                "url": "https://documents.ucr.edu/registrar/UCR%20Catalog%202026-2027.pdf#page=110"
            },
            "majors": [
                {
                    "name": "Public Policy",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
